export const PROJECT_LINK_TYPE = {
  SELF: 'SELF'
};
